import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "context/appContext";
import { AnimatePresence, motion } from "framer-motion";
import { useAppDispatch } from "hooks/hooks";
import { Helmet } from "react-helmet";
import CommonLayout from "./CommonLayout";
import { PhoneCallIcon } from "lucide-react";
import { Switch } from "@mui/material";
import { updatePhoneAvailibilty } from "redux/features/auth/authSlice";

const ClientSubscriptonParameterPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const authContext = useContext(AuthContext);
  const [localShowPhoneNumber, setLocalShowPhoneNumber] = useState(authContext?.user?.showPhoneNumber ?? false);
  useEffect(() => {
    setLocalShowPhoneNumber(authContext?.user?.showPhoneNumber ?? false);
  }, [authContext?.user?.showPhoneNumber]);

  const handleToggle = async () => {
    const newValue = !localShowPhoneNumber;
    setLocalShowPhoneNumber(newValue);
    await dispatch(updatePhoneAvailibilty({ showPhoneNumber: newValue }));
    authContext.setUser((prev: any) => ({
      ...prev,
      showPhoneNumber: newValue,
    }));
  };

  return (
    <div className="nc-AccountPage" data-nc-id="AccountPage">
      <Helmet>
        <title>EventToBee | Location d'espaces : salles, lofts, jardins & boutiques – Paris & Île-de-France</title>
      </Helmet>
      <CommonLayout>
        <AnimatePresence>
          <motion.div
            className="max-w-2xl mx-auto overflow-hidden bg-white border border-gray-200 shadow-xl rounded-2xl"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.5 }}
          >
            <div className="p-8 bg-eventToBee">
              <div className="flex items-center justify-center mb-6">
                <h2 className="text-3xl font-bold text-white">Paramètres de l'abonnement</h2>
              </div>
            </div>
            <div className="p-8 space-y-6">
              <motion.div
                className="grid grid-cols-1 gap-6 sm:grid-cols-2"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ staggerChildren: 0.2 }}
              >
                <motion.div
                  className="flex items-start p-4 space-x-4 transition-colors duration-200 rounded-lg bg-gray-50 hover:bg-gray-100"
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                >
                  <PhoneCallIcon className="flex-shrink-0 w-8 h-8 text-indigo-600" />
                  <div className="flex items-center justify-between w-full">
                    <div className="text-sm text-gray-600">Numéro de téléphone</div>
                    <div className="text-base font-semibold text-gray-900">
                      <Switch checked={localShowPhoneNumber} onChange={handleToggle} />
                    </div>
                  </div>
                </motion.div>
              </motion.div>
            </div>
          </motion.div>
        </AnimatePresence>
      </CommonLayout>
    </div>
  );
};

export default ClientSubscriptonParameterPage;
